import axios from 'axios';

/**
 * 🛠 CẤU HÌNH API CHUẨN
 * baseURL: '/api' là cách tối ưu nhất khi dùng chung domain với Nginx.
 * Khi gọi api.post('/auth/login'), nó sẽ tự tạo thành: https://nexbot.vn/api/auth/login
 */
const api = axios.create({
    baseURL: 'https://nexbot.vn', 
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
    withCredentials: true,
    timeout: 30000 
});

api.interceptors.request.use(
    (config) => {
        // Xử lý FormData (không được set Content-Type thủ công khi gửi file)
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }

        // Lấy token từ localStorage
        const token = localStorage.getItem('token') || localStorage.getItem('jwtToken');
        
        if (token) {
    const cleanToken = token.replace(/['"]+/g, '');
    config.headers['Authorization'] = `Bearer ${cleanToken}`; // Dùng Bearer
    config.headers['x-auth-token'] = cleanToken; // Một số backend dùng header này
}

        // Chống cache cho các request GET
        if (config.method === 'get') {
            config.params = { ...config.params, _t: Date.now() };
        }
        
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Bắt lỗi nếu server trả về trang HTML (thường là lỗi 404 hoặc 500 do Nginx)
        if (error.response && typeof error.response.data === 'string' && error.response.data.includes('<!doctype html>')) {
            console.error("❌ API trả về HTML (Lỗi định tuyến hoặc Nginx):", error.config.url);
            return Promise.reject({ message: "Máy chủ đang gặp sự cố, vui lòng thử lại sau." });
        }

        const status = error.response ? error.response.status : null;

        // Tự động thoát nếu token hết hạn hoặc không hợp lệ
        if (status === 401 || status === 403) {
            console.warn("⚠️ Phiên làm việc hết hạn, chuyển hướng về đăng nhập...");
            localStorage.clear();
            if (window.location.pathname !== '/login') {
                window.location.replace('/login');
            }
        }
        
        return Promise.reject(error);
    }
);

export default api;